import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";

@Injectable()
export class FeaturedListingService {
  latamCountry = "";
  constructor(private http: HttpClient) {}

  private buildinglistingResource = `/buildinglisting`;

  async checkListingDetailRoute(id: any, lang?: string) {
    console.error(
      "checkListingDetailRoute is deprecated, use getSpotBuildingDetailURLFormat instead"
    );
    /*
    return await this.http
      .get(environment.apiURL + "/listings/" + id + "/detail/url-data/" + lang)
      .toPromise()
      .then((result: any) => {
        return result;
      });
      */
    return undefined;
  }

  getSpotBuildingDetailURLFormat(id: any, lang?: string) {
    const url =
      (this.latamCountry == "latamMx"
        ? environment.apiURLMX
        : this.latamCountry == "latamBr"
        ? environment.apiURLBR
        : "/api") +
      `${this.buildinglistingResource}/${id}/detail/url-data/${lang}`;

    return this.http
      .get(url, { observe: "response" })
      .pipe(
        map(
          (val: any) =>
            `${
              this.latamCountry == "latamMx"
                ? environment.spotURLMx
                : environment.spotURL
            }/${val.body.detailsURL}`
        )
      );
  }
}
